import { Component } from 'react';
import menuImage from 'images/menu.svg';
import menuOnImage from 'images/menu_on.svg';
import Navigation from 'components/molecules/Navigation';
import facebookLogo from 'images/sociallink_facebook_dark.svg';
import instagramLogo from 'images/sociallink_instagram_dark.svg';
import twitterLogo from 'images/sociallink_twitter_dark.svg';
import youtubeLogo from 'images/sociallink_youtube_dark.svg';
import whatsappLogo from 'images/sociallink_whatsapp_dark.svg';
import './MobileNavigation.scss';

class MobileNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  render() {
    const status = this.state.open ? 'open' : null;

    return (
      <div
        className={
          'mobileNavigation ' + (status ? ' mobileNavigation-' + status : '')
        }
      >
        <div className="mobileNavigation__button">
          <button onClick={() => this.setState({ open: true })}>
            <img src={menuImage} alt="" />
          </button>
        </div>
        <div className="mobileNavigation__navigation">
          <div className="mobileNavigation__main_navigation">
            <button onClick={() => this.setState({ open: false })}>
              <img src={menuOnImage} alt="" />
            </button>
            <Navigation />
          </div>
          <div className="mobileNavigation__footer">
            <div className="mobileNavigation__address">
              <p>San Martín Sur 600, Godoy Cruz, Mendoza.</p>
              <p>Av. Bartolomé Mitre 530, San Rafael, Mendoza.</p>
              <p>Paula Albarracín de Sarmiento 699, San Juan.</p>
            </div>
            <div className="mobileNavigation__social">
              <a
                href="https://www.facebook.com/profile.php?id=61583755955687"
                target="_blank"
                rel="noopener noreferrer"
                className="mobileNavigation__social__link"
              >
                <img src={facebookLogo} alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/yacopininissan/"
                target="_blank"
                rel="noopener noreferrer"
                className="mobileNavigation__social__link mobileNavigation__social__link-instagram"
              >
                <img src={instagramLogo} alt="Instagram" />
              </a>

              <a
                href="https://wa.me/5492616548107 "
                target="_blank"
                rel="noopener noreferrer"
                className="mobileNavigation__social__link mobileNavigation__social__link-whatsapp"
              >
                <img src={whatsappLogo} alt="Whatsapp" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MobileNavigation;
